import _extends from "@swc/helpers/src/_extends.mjs";
import React, { lazy, Suspense } from 'react';
import LoadingIndicator from '@wix/da-shared-react/pkg/LoadingIndicator';
import ErrorBoundary from '@wix/da-shared-react/pkg/ErrorBoundary';
import retry from '@wix/da-shared-react/pkg/utils/webpack/chunkRetry';
const LoadableRedux = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "adopts_buyer_shared" */ '../redux/BuyerModuleLoader')));
const LoadableModal = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "adopts_buyer_shared" */ './BuyerModal')));
const BuyerModalLoadable = (props)=>/*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "BuyerModalLoadable"
    }, /*#__PURE__*/ React.createElement(Suspense, {
        fallback: /*#__PURE__*/ React.createElement(LoadingIndicator, {
            view: 'llama',
            withOverlay: true,
            usePortal: true
        })
    }, /*#__PURE__*/ React.createElement(LoadableRedux, null), /*#__PURE__*/ React.createElement(LoadableModal, _extends({}, props))));
BuyerModalLoadable.displayName = 'BuyerModalLoadable';
export default BuyerModalLoadable;
